export const SIGN_UP = "/signup";
export const SIGN_IN = "/signin";
export const HOME = "/home";
export const DATABASES = "/home/databases";
export const CLIENTS = "/home/clients";
